"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TooltipClose;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("@ux/button"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Render the close button of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} button
 * @private
 */
function TooltipClose(_ref) {
  let {
    close,
    className,
    ariaLabels
  } = _ref;
  let activeElement;
  (0, _react.useEffect)(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    activeElement = document && document.activeElement;
    const button = document.querySelector(`.${className}`);
    if (button) button.focus();
    return () => {
      if (activeElement) activeElement.focus();
    };
  });
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.close,
    type: "button",
    className: className,
    onClick: close,
    design: 'stateless',
    icon: /*#__PURE__*/_react.default.createElement(_x.default, null)
  });
}
TooltipClose.defaultProps = {
  ariaLabels: {
    close: 'Close Tooltip'
  }
};

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipClose.propTypes = {
  close: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  ariaLabels: _propTypes.default.shape({
    close: _propTypes.default.string
  })
};